import { SettlementOption } from "@covertree/new-business-graphql";

export function mapStringToSettlementOption(
  settlementOption: string
): SettlementOption {
  switch (settlementOption) {
    case "Actual Cash Value":
      return SettlementOption.ActualCashValue;
    case "Replacement Cost":
      return SettlementOption.ReplacementCost;
    case "Extended Replacement Cost":
      return SettlementOption.ExtendedReplacementCost;
    case "Full Repair Cost":
      return SettlementOption.FullRepairCost;
    default:
      throw new Error("Unknown value for SettlementOption");
  }
}
